import React from "react";
import PropTypes from "prop-types";
import { easilGrayXDark } from "./style.module.css";

const UnmuteIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 20}
    height={height || size || 20}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
  >
    <g fill="none" fillRule="evenodd">
      <rect width="20" height="20" rx="4" />
      <path d="M3 3h14v14H3z" />
      <path
        d="M5 7.5h1.5L10 5v10l-3.5-2.5H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1z"
        stroke={color || easilGrayXDark}
        strokeWidth="1.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 7a9.487 9.487 0 0 1 0 6h0M14.5 5a11.18 11.18 0 0 1 0 10h0"
        stroke={color || easilGrayXDark}
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
UnmuteIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default UnmuteIcon;
